import { render, staticRenderFns } from "./service_shipping.vue?vue&type=template&id=2849b46e&scoped=true"
import script from "./service_shipping.vue?vue&type=script&lang=js"
export * from "./service_shipping.vue?vue&type=script&lang=js"
import style0 from "./service_shipping.vue?vue&type=style&index=0&id=2849b46e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849b46e",
  null
  
)

export default component.exports